import { Directive, ElementRef, EventEmitter, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Directive({
  selector: '[appSecureImage]'
})
export class SecureImageDirective implements OnInit {
  @Output() imageResolved = new EventEmitter<boolean>();

  constructor(private el: ElementRef, private http: HttpClient) {}

  ngOnInit() {
    const imageUrl = this.el.nativeElement.src;
    this.el.nativeElement.src = ''; // Prevents original image from loading

    // Fetching image as blob
    this.http.get(imageUrl, { responseType: 'blob' }).subscribe((response) => {
      // Creating an object URL for the blob data and setting it as the src of the image
      const reader = new FileReader();
      reader.onloadend = () => {
        this.el.nativeElement.src = reader.result;
        console.log('Image resolved');
        this.imageResolved.emit(true);
      };
      reader.readAsDataURL(response);
    });
  }
}
